// Imports




// rafce

const CombosCard = ({item}) => {


  // Component
  return (
    <div className="banner-card-info">
      <div className='banner-card-image'>
        <span>Cód. {item.code}</span>
        <img src={item.picture} alt="Foto del Combo" />
      </div>
      <div className='banner-card-description'>
        <h2>{item.name}</h2>
        <span>$ {item.price.toFixed(2)}</span>
      </div>
    </div>
  )
}

export default CombosCard

